var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5755 3.92546C20.5755 3.92546 20.3812 2.55768 19.7867 1.9554C19.0328 1.1647 18.1857 1.16083 17.7992 1.11419C15.0208 0.914063 10.8553 0.914062 10.8553 0.914062H10.8476C10.8476 0.914062 6.682 0.914063 3.90368 1.11419C3.51711 1.16083 2.67 1.1647 1.91617 1.9554C1.32166 2.55768 1.12738 3.92546 1.12738 3.92546C1.12738 3.92546 0.929199 5.53028 0.929199 7.13708V8.64278C0.929199 10.2496 1.12738 11.8543 1.12738 11.8543C1.12738 11.8543 1.32166 13.2221 1.91617 13.8245C2.67195 14.6152 3.66277 14.5899 4.10381 14.6734C5.69117 14.825 10.8514 14.8735 10.8514 14.8735C10.8514 14.8735 15.0208 14.8678 17.7992 14.6657C18.1877 14.619 19.0328 14.6152 19.7867 13.8245C20.3812 13.2221 20.5755 11.8543 20.5755 11.8543C20.5755 11.8543 20.7736 10.2476 20.7736 8.64278V7.13708C20.7736 5.53028 20.5755 3.92546 20.5755 3.92546ZM8.80169 10.4672V4.89109L14.1641 7.68886L8.80169 10.4672Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.5fd8c2c3b69b21959a560dc0c1fc3a3b.svg";
export { ForwardRef as ReactComponent };